/* eslint-disable no-undef */
// @ts-nocheck
/**
 * Cart Page Redirect
 * Redirects /cart to previous page and opens cart drawer instead
 */
(function() {
  'use strict';

  // Check if we need to open cart drawer (redirected from /cart)
  function checkOpenCartDrawer() {
    if (sessionStorage.getItem('openCartDrawer') === 'true') {
      sessionStorage.removeItem('openCartDrawer');
      // Small delay to ensure cart drawer component is ready
      setTimeout(function() {
        var cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          // Fallback: try to click the cart button
          var cartButton = document.querySelector('[data-cart-drawer-trigger], .header-actions__cart-icon, [href*="cart"]');
          if (cartButton) cartButton.click();
        }
      }, 100);
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkOpenCartDrawer);
  } else {
    checkOpenCartDrawer();
  }
})();
